import axios from 'axios';
import { VUE_APP_API_URL } from "./runtime";
import { VUE_APP_API_KEY } from "./runtime";
import { apiResponse } from "./types";

export class Api {

    static headers(contentType: string) {
        return {
            headers: {
                'Content-Type': contentType,
                'x-api-key': `${VUE_APP_API_KEY}`
            }
        }
    }
    static matchForFreetext(text: string, country: string, language: string,
        standard: string, gsClass: string, confToTriggerFuzzy: string): Promise<apiResponse> {
        const formData = new FormData();
        formData.append('text', text);
        formData.append('country', country);
        formData.append('language', language);
        formData.append('standard', standard);
        formData.append('class', gsClass);
        formData.append('confToTriggerFuzzy', confToTriggerFuzzy);
        return axios.post(
            // `${VUE_APP_API_URL}/goods-services-freetext`, # sticking with alias as this is the url has been set on the dev ops cfgs
            `${VUE_APP_API_URL}/match-goods-services`,
            formData,
            Api.headers('multipart/form-data'),
        ).then((r) => r.data).catch((error) => ({
            error: error.response.data.error,
            queryText: text,
            resultsBag: [],
            queryTrademark: null
        }));
    }

    static matchForTrademark(tmid: string, country: string, language: string,
        standard: string, gsClass: string, confToTriggerFuzzy: string): Promise<apiResponse> {
        const formData = new FormData();
        formData.append('tmid', tmid);
        formData.append('country', country);
        formData.append('language', language);
        formData.append('standard', standard);
        formData.append('class', gsClass);
        formData.append('confToTriggerFuzzy', confToTriggerFuzzy);
        return axios.post(
            // `${VUE_APP_API_URL}/goods-services-tmid`,# sticking with alias as this is the url has been set on the dev ops cfgs
            `${VUE_APP_API_URL}/match-classes`,
            formData,
            Api.headers('multipart/form-data'),
        ).then((r) => r.data).catch((error) => ({
            error: error.response.data.error,
            queryText: "",
            resultsBag: [],
            queryTrademark: null
        }));
    }
}


